import _ from 'lodash';

import Logger from '../logger';
import { API_V1 } from './APIs/APIv1';
import { ProfileValues } from '../types/profile.types';

export const addProfile = async (name: string, profile: ProfileValues) => {
  try {
    const postObj: any = { name, step: profile, companyWideVisibility: true };
    const response = await API_V1.post('/profiles', postObj);
    return response.data;
  } catch (e) {
    Logger.trace('Error while adding new profile with step values');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};
